export default "__VITE_PUBLIC_ASSET__35485149__"